import { Box, Typography } from "@mui/material";
import { StyledButton } from "customStyled";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

const NotFound = ({ path }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        margin: 0,
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      }}
    >
      <Typography variant="h1">{t("n404PageNotFound")}</Typography>
      <Typography variant="body">
        {t("sorryPageLookingCouldNot")}
      </Typography>
      <Box
        sx={{
          mt: 2,
          textAlign: "center"
        }}>
        <StyledButton variant="contained" onClick={() => navigate(`/${path}`)}>{t("goBackHome")}</StyledButton>
      </Box>
    </Box>
  );
};

export default NotFound;
